<template>
  <div>
    <v-toolbar flat>
      <base-breadcrumbs :items="breadcrumbs" />
    </v-toolbar>
    <detail-kelompok :detail="detail" />
    <detail-laporan v-if="Object.keys(periodes).length" :detail="detail" :config="config" :periodes="periodes" />
  </div>
</template>

<script>
import BaseBreadcrumbs from '@components/base/BaseBreadcrumbs';
import DetailKelompok from './detail/Kelompok';
import DetailLaporan from './detail/Laporan';
import { mapActions } from 'vuex';

export default {
  name: 'PendidikanDetail',
  components: { BaseBreadcrumbs, DetailKelompok, DetailLaporan },
  data() {
    return {
      detail: {},
      config: {},
      periodes: {},
    };
  },
  computed: {
    pspKpPaId() {
      return this.$route.params.psp_kp_pa_id || null;
    },

    breadcrumbs() {
      return [
        { text: 'Daftar Kelompok Satuan Pendidikan', to: 'laporan-lingkup-pendidikan' },
        { text: this.$getDeepObj(this.detail, 'nama') },
      ];
    },
  },
  created() {
    this.getDetailKelompok();
    this.getMasters('lokakarya_moda_psp;lingkup_moda_psp');
  },
  methods: {
    ...mapActions('master', ['getMasters']),
    ...mapActions('laporan', ['getDetail']),

    getDetailKelompok() {
      const attr = { endpoint: 'pendampingan-lingkup' };
      const id = this.pspKpPaId;

      if (!id) return;

      this.getDetail({ attr, id }).then(({ data, meta }) => {
        this.detail = data || {};
        this.config = meta?.config || {};
        this.periodes['pendampingan_ke-visitasi'] = meta['pendampingan_ke-visitasi'] || null;
        this.periodes['pendampingan_ke-refleksi'] = meta['pendampingan_ke-refleksi'] || null;
      });
    },
  },
};
</script>

<style scoped></style>
